import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ecef404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content rel" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["onMouseenter"]
const _hoisted_4 = { class: "abs bg" }
const _hoisted_5 = {
  key: 0,
  class: "flex-col-ter"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "flex-cen"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "flex-cen"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]

import { ref, computed, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, useSite2Station, useSite, isD2C, isJA } from '@/store'
import AppLink from '@/components/common/AppLink.vue'
import { bury } from '@/util/useBury'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  props: ['list', 'wrapNum'],
  setup(__props) {

const props = __props

const stationCode = useSite2Station()

const data = computed(() => {
  const arr: any = []
  let row: any = null
  if (!props.list) return arr
  props.list.forEach((v: any, i: any) => {
    if (i % (props.wrapNum ? props.wrapNum : 10) === 0) {
      arr.push([])
      row = arr[arr.length - 1]
    }
    row.push(v)
  })
  return arr
})

const box: any = ref(null)
const d: any = reactive({ x: null, y: null })
const handleEnter = (i: any, j: any) => {
  // if (e.target.tagName === 'IMG') {
  //   const { left, top } = box.value.getBoundingClientRect()
  //   d.x = e.clientX - parseInt(left)
  //   d.y = e.clientY - parseInt(top)
  // }
  cur.value = [i, j].join('-')
  d.x = i * 120 + 60
  d.y = j * 100 + 50
}
const handleLeave = () => {
  d.x = null
  d.y = null
}
const cur = ref()

// 因为没有标志这些平台的唯一key，所以从platformUrl取对应的关键字
const judgePlatTypeByName = (path: string) => {
  if (path.includes('taobao') || path.includes('tmall') || path.includes('1688')) {
    return '1'
  } else
  // 亚马逊 || 乐天市场
  if (path.includes('amazon') || path.includes('rakuten')) {
    return '2'
  } else {
    return '3'
  }
}

// 跳转外链
const handleJump = (path: string) => {
  window.open(path)
}

// 只有淘宝、天猫、1688三个站内平台
const linkInStation = (path: string) => {
  if (path.includes('taobao') || path.includes('tmall') || path.includes('1688')) {
    const preifx = isD2C() ? '/d2c' : '/b2b'
    const url = toPlatform(path)
    window.open(`${preifx}${url}`)
  }
}

const toPlatform = (path: string) => {
  if (path.includes('taobao')) {
    return '/index/platform/taobao'
  } else if (path.includes('tmall')) {
    return '/index/platform/tmall'
  } else if (path.includes('1688')) {
    return '/index/platform/1688'
  }
}

const getScale = (i: any, j: any) => {
  let s = 1
  i = i * 120 + 60
  j = j * 100 + 50
  if (d.x === i && d.y - j === 100) {
    return { transform: 'scale(0.92)', transformOrigin: 'top center' }
  } else if (d.x !== null && Math.abs(j - d.y) < 50) {
    s = (Math.pow(480 - Math.min(480, Math.hypot(i - d.x, j - d.y)), 4) / Math.pow(680, 4)) + 1
  }
  return { transform: `scale(${s})` }
}

const getWidth = (i: any, j: any) => {
  let s = 1
  i = i * 120 + 60
  j = j * 100 + 50
  if (d.x !== null && Math.abs(j - d.y) < 50) {
    s = (Math.pow(480 - Math.min(480, Math.hypot(i - d.x, j - d.y)), 4) / Math.pow(750, 4)) + 1
  }
  return { width: 120 * s + 'px' }
}
// 图标同步跳转
const jump = (v:any) => {
  console.log('v', v)
  if (judgePlatTypeByName(v.platformUrl) === '1') {
    // 日本站不跳转
    if (!isJA()) {
      bury('ECBuy_Click_PlatformChannel', v.platformName)
      linkInStation(v.platformUrl)
    }
  } else {
    bury('ECBuy_Click_Detail', v.platformName)
    handleJump(v.platformUrl)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "rel",
      ref: (_value, _refs) => {
        _refs['box'] = _value
        box.value = _value
      },
      onMouseleave: handleLeave
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (row, j) => {
        return (_openBlock(), _createElementBlock("div", { key: j }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "rel item",
                key: v.onlineManageId,
                style: _normalizeStyle(getWidth(i, j))
              }, [
                _createElementVNode("div", {
                  class: "mask flex-cen abs",
                  onMouseenter: ($event: any) => (handleEnter(i, j)),
                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (cur.value = null))
                }, [
                  _createVNode(_Transition, {
                    "enter-active-class": "animated fast zoomIn",
                    "leave-active-class": "animated fast zoomOut"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_4, [
                        (judgePlatTypeByName(v.platformUrl) === '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("div", {
                                class: "enter dark box-lg-shadow",
                                onClick: ($event: any) => {_unref(bury)('ECBuy_Click_PlatformChannel',v.platformName);linkInStation(v.platformUrl)}
                              }, _toDisplayString(_unref(t)('平台频道')), 9, _hoisted_6),
                              _withDirectives(_createElementVNode("div", {
                                class: "enter box-lg-shadow",
                                onClick: ($event: any) => {_unref(bury)('ECBuy_Click_ToBuy',v.platformName);handleJump(v.platformUrl)}
                              }, _toDisplayString(_unref(t)('去购买')), 9, _hoisted_7), [
                                [_vShow, _unref(stationCode) ===  _unref(Site).JA]
                              ])
                            ]))
                          : (judgePlatTypeByName(v.platformUrl) === '2')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", {
                                  class: "btn enter dark box-lg-shadow",
                                  onClick: _withModifiers(($event: any) => {{_unref(bury)('ECBuy_Click_Detail',v.platformName);handleJump(v.platformUrl)}}, ["stop"])
                                }, _toDisplayString(_unref(t)('去选品')), 9, _hoisted_9)
                              ]))
                            : (judgePlatTypeByName(v.platformUrl) === '3')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("div", {
                                    class: "btn enter dark box-lg-shadow",
                                    onClick: _withModifiers(($event: any) => {{_unref(bury)('ECBuy_Click_Detail',v.platformName);handleJump(v.platformUrl)}}, ["stop"])
                                  }, _toDisplayString(_unref(t)('去看看')), 9, _hoisted_11)
                                ]))
                              : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, cur.value === [i, j].join('-')]
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", {
                    class: "rel abs",
                    style: _normalizeStyle(getScale(i, j)),
                    onClick: ($event: any) => (jump(v))
                  }, [
                    _createElementVNode("img", {
                      class: "rel",
                      referrerPolicy: "no-referrer",
                      src: v.platformImageUrl,
                      alt: ""
                    }, null, 8, _hoisted_13),
                    (v.platformName.includes('1688'))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(`selected1688 selected1688-${_unref(useSite)()}`)
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 12, _hoisted_12)
                ], 40, _hoisted_3)
              ], 4))
            }), 128))
          ])
        ]))
      }), 128))
    ], 544)
  ]))
}
}

})